import { MinimalButton } from '@calendly/ui/components/minimal-button';
import classNames from 'classnames';
import { useContext, forwardRef } from 'react';
import { useTrack } from 'hooks/analytics_events';
import { MeetingDetailDependenciesContext } from '../../../meeting_detail_context';
const buttonContainerCss = "b1x7all2";
const ButtonContainer = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(buttonContainerCss, props.className)} />;
});
export const ShowMoreButton = ({
  children,
  disabled = false,
  event,
  expand
}) => {
  const dependencies = useContext(MeetingDetailDependenciesContext);
  if (!dependencies?.getViewMoreInviteesAnalyticsPayload) {
    throw new Error('ShowMoreButton must be wrapped in a MeetingDetailDependenciesProvider with getViewMoreInviteesAnalyticsPayload');
  }
  const track = useTrack();
  const handleClick = () => {
    const payload = dependencies.getViewMoreInviteesAnalyticsPayload(event);
    track(payload);
    expand();
  };
  return <ButtonContainer>
      <MinimalButton disabled={disabled} onClick={handleClick}>
        {children}
      </MinimalButton>
    </ButtonContainer>;
};

require("./show_more_button.wyw-in-js.css!=!../../../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./show_more_button.js");